import React, { useEffect } from 'react';

export default function NewsTarget(props) {
    useEffect(() => {
        window.dispatchEvent(new CustomEvent('news-container-ready'));
    }, []);

    return (
        <div id="news-container"></div>
    );
}
